import React from "react"


class CutOffDate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>

            </section>
        )
    }

}

export default CutOffDate


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/CutOffDate.js